import { useEffect } from "react"
import { useNavigate } from "react-router-dom"

export default function useBackButtonGuard({ onLogout }) {
    const navigate = useNavigate()

    useEffect(() => {
        window.history.pushState(null, '', window.location.href)

        const handlePopState = () => {
            window.history.pushState(null, '', window.location.href)
            onLogout()
        }

        window.addEventListener('popstate', handlePopState)
        return () => window.removeEventListener('popstate', handlePopState)
    }, [onLogout])
}
